export default __webpack_public_path__ + "52d3544fdcc512fc4edef43919cd56b1.svg";